/*
 * Breakdown
 */

import {
  ROUTE_BENEFICIARY_FILE,
  ROUTE_BENEFICIARY_FILE_LABEL,
  ROUTE_BENEFICIARY_FILE_STATUS,
  ROUTE_BENEFICIARY_FILE_STATUS_LABEL,
  ROUTE_BENEFICIARY_SERVICES,
  ROUTE_BENEFICIARY_SERVICES_LABEL,
  ROUTE_DASHBOARD,
  ROUTE_DASHBOARD_LABEL,
} from "../navigation/routes";
import { BreakdownTire, BreakdownType, PluginView } from "./enums";

export const BreakdownDiagramCoordinates = Object.entries({
  [BreakdownType.ENGINE]: {
    colStart: 5,
    rowStart: 2,
    colSpan: 4,
    rowSpan: 4,
    placement: "right",
  },
  [BreakdownTire.FRONT_LEFT]: {
    colStart: 2,
    rowStart: 4,
    colSpan: 3,
    rowSpan: 5,
    placement: "left",
  },
  [BreakdownTire.FRONT_RIGHT]: {
    colStart: 9,
    rowStart: 4,
    colSpan: 3,
    rowSpan: 5,
    placement: "right",
  },
  [BreakdownTire.REAR_LEFT]: {
    colStart: 2,
    rowStart: 15,
    colSpan: 3,
    rowSpan: 5,
    placement: "left",
  },
  [BreakdownTire.REAR_RIGHT]: {
    colStart: 9,
    rowStart: 15,
    colSpan: 3,
    rowSpan: 5,
    placement: "right",
  },
});

/*
 * Plugin
 */

export const PluginGridLayout = {
  TemplateColumns: {
    [PluginView.STANDARD]: "repeat(1, 1fr)",
    [PluginView.LARGE]: "repeat(8, 1fr)",
    [PluginView.FULL]: "repeat(24, 1fr)",
  },
  TemplateRows: {
    [PluginView.STANDARD]: "repeat(2, 1fr)",
    [PluginView.LARGE]: "repeat(2, 1fr)",
    [PluginView.FULL]: "repeat(2, 1fr)",
  },
  VehicleCard: {
    ColSpan: {
      [PluginView.STANDARD]: 1,
      [PluginView.LARGE]: 4,
      [PluginView.FULL]: 8,
    },
    RowSpan: {
      [PluginView.STANDARD]: 1,
      [PluginView.LARGE]: 1,
      [PluginView.FULL]: 1,
    },
  },
  LocationCard: {
    ColSpan: {
      [PluginView.STANDARD]: 1,
      [PluginView.LARGE]: 4,
      [PluginView.FULL]: 8,
    },
    RowSpan: {
      [PluginView.STANDARD]: 1,
      [PluginView.LARGE]: 1,
      [PluginView.FULL]: 1,
    },
  },
  ChatCard: {
    ColSpan: {
      [PluginView.STANDARD]: 0,
      [PluginView.LARGE]: 0,
      [PluginView.FULL]: 8,
    },
    RowSpan: {
      [PluginView.STANDARD]: 0,
      [PluginView.LARGE]: 0,
      [PluginView.FULL]: 1,
    },
  },
  CameraCard: {
    ColSpan: {
      [PluginView.STANDARD]: 0,
      [PluginView.LARGE]: 8,
      [PluginView.FULL]: 24,
    },
    RowSpan: {
      [PluginView.STANDARD]: 0,
      [PluginView.LARGE]: 1,
      [PluginView.FULL]: 1,
    },
  },
};

export const breadcrumbList = [
  { label: ROUTE_DASHBOARD_LABEL, link: () => ROUTE_DASHBOARD },
  {
    label: ROUTE_BENEFICIARY_FILE_LABEL,
    link: (beneficiaryId) => ROUTE_BENEFICIARY_FILE(beneficiaryId),
  },
  {
    label: ROUTE_BENEFICIARY_SERVICES_LABEL,
    link: (beneficiaryId) => ROUTE_BENEFICIARY_SERVICES(beneficiaryId),
  },
  {
    label: ROUTE_BENEFICIARY_FILE_STATUS_LABEL,
    link: (beneficiaryId) => ROUTE_BENEFICIARY_FILE_STATUS(beneficiaryId),
  },
];
